import { InjectionToken } from "@angular/core";

export const PUSH_NOTIFICATION_OPTIONS = new InjectionToken<PushNotificationOptions>('PUSH_NOTIFICATION_OPTIONS');

export interface PushNotificationOptions {
    isEnabled: boolean;
}